export default {
  FETCH_PRIVILEGE_TEMPLATES_REQUEST: 'FETCH_PRIVILEGE_TEMPLATES_REQUEST',
  FETCH_PRIVILEGE_TEMPLATES_SUCCESS: 'FETCH_PRIVILEGE_TEMPLATES_SUCCESS',
  FETCH_PRIVILEGE_TEMPLATES_FAILURE: 'FETCH_PRIVILEGE_TEMPLATES_FAILURE',

  CREATE_PRIVILEGE_TEMPLATE_REQUEST: 'CREATE_PRIVILEGE_TEMPLATE_REQUEST',
  CREATE_PRIVILEGE_TEMPLATE_SUCCESS: 'CREATE_PRIVILEGE_TEMPLATE_SUCCESS',
  CREATE_PRIVILEGE_TEMPLATE_FAILURE: 'CREATE_PRIVILEGE_TEMPLATE_FAILURE',

  UPDATE_PRIVILEGE_TEMPLATE_REQUEST: 'UPDATE_PRIVILEGE_TEMPLATE_REQUEST',
  UPDATE_PRIVILEGE_TEMPLATE_SUCCESS: 'UPDATE_PRIVILEGE_TEMPLATE_SUCCESS',
  UPDATE_PRIVILEGE_TEMPLATE_FAILURE: 'UPDATE_PRIVILEGE_TEMPLATE_FAILURE',

  DELETE_PRIVILEGE_TEMPLATE_REQUEST: 'DELETE_PRIVILEGE_TEMPLATE_REQUEST',
  DELETE_PRIVILEGE_TEMPLATE_SUCCESS: 'DELETE_PRIVILEGE_TEMPLATE_SUCCESS',
  DELETE_PRIVILEGE_TEMPLATE_FAILURE: 'DELETE_PRIVILEGE_TEMPLATE_FAILURE',

  SELECT_PRIVILEGE_TEMPLATE: 'SELECT_PRIVILEGE_TEMPLATE',
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/actions/action-types.js